import React, { useEffect, useState } from 'react'
import * as R from 'ramda'
import { Link, useLocation } from 'react-router-dom'
import { Container, Divider } from 'semantic-ui-react'
import AuthenticationShell from 'shared/components/AuthenticationShell'
import Page from 'shared/components/Page'

import Title from 'shared/components/Title'

export default function CheckVerifyEmail() {
  const location = useLocation()
  const [email, setEmail] = useState('')

  useEffect(() => {
    const newEmail = R.path(['state', 'email'], location)
    if (newEmail) {
      setEmail(newEmail)
    }
  }, [location])

  return (
    <Page>
      <AuthenticationShell
        headerText={
          <>
            <i className="icon far fa-envelope" /> Check your email
          </>
        }
      >
        <Title title="Check your email" />
        <Container textAlign="center">
          <p>
            We've just sent an email to <strong>{email}</strong> with a link you'll need to click to
            verify your account.
          </p>
          <Divider hidden />
          <Link to={{ pathname: '/login/', search: location.search }}>
            <i className="fas fa-arrow-left icon" />
            Back to login
          </Link>
        </Container>
      </AuthenticationShell>
    </Page>
  )
}



// WEBPACK FOOTER //
// ./node_modules/eslint-loader??ref--0-0!./src/pages/SignUp/CheckVerifyEmail.js